import React from 'react';
import { Link, useParams } from 'react-router-dom';

import SwissGroupPanel from './swiss-group-panel';

const SwissStandings: React.FC = () => {
  const { id: tournamentId, categoryId } = useParams<{ id: string; categoryId: string }>();

  if (!categoryId) {
    return <div className="participants-error">Nie udało się załadować rund.</div>;
  }

  return (
    <div className="swiss-page">
      <Link to={`/events/${tournamentId}`} className="participants-back">
        ← Powrót do turnieju
      </Link>
      <SwissGroupPanel categoryId={categoryId} heading="h1" />
    </div>
  );
};

export default SwissStandings;
